<template>
  <div class="register-box">
    <div class="register-logo">
      <a><b>Cabinet</b> Business</a>
    </div>

    <div class="register-box-body">
      <p class="login-box-msg">Account Activation</p>

      <div class="form-group has-feedback">
        <input v-model="email" type="email" class="form-control" placeholder="Email">
        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
      </div>
      <div class="form-group has-feedback">
        <input v-model="newPassword" type="password" class="form-control" placeholder="Password">
        <span class="glyphicon glyphicon-lock form-control-feedback"></span>
      </div>
      <div class="form-group has-feedback">
        <input v-model="repeatedPassword" type="password" class="form-control" placeholder="Retype password">
        <span class="glyphicon glyphicon-log-in form-control-feedback"></span>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <span class="text-red">{{errorMessage}}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-8">
          <div class="checkbox icheck">

          </div>
        </div>
        <!-- /.col -->
        <div class="col-xs-4">
          <button v-on:click="activate" type="submit" class="btn btn-primary btn-block btn-flat">Activate</button>
        </div>
        <!-- /.col -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ActivateAccount',
  data: function () {
    return {
      activatingToken: null,
      email: null,
      newPassword: null,
      repeatedPassword: null,
      errorMessage: null
    };
  },
  created () {
    var token = this.$route.query['token'];
    if (token === undefined) {
      this.errorMessage = 'You have an invalid activation link. Please, contact the Sportlane support team';
      return;
    }

    this.activatingToken = token;
  },
  methods: {
    activate: function () {
      var self = this;

      self.errorMessage = null;

      if (self.email === undefined || self.email === '' || self.email === null) {
        self.errorMessage = 'Type your e-mail';
        return;
      }

      if (self.newPassword === undefined || self.newPassword === '' || self.newPassword === null) {
        self.errorMessage = 'Set a password';
        return;
      }

      if (self.newPassword !== self.repeatedPassword) {
        self.errorMessage = 'For confirmation purposes the passwords should match';
        return;
      }
      axios.post(
        window.rootRoute + '/account/activate',
        {
          activatingToken: this.activatingToken,
          email: this.email,
          newPassword: this.newPassword
        })
        .then(function () {
          alert('Your account has been successfully activated. You can log in into your Cabinet account now and start working');
          window.location.replace('/signin');
        })
        .catch(function (error) {
          if (error.response.status === 400) {
            self.errorMessage = 'You entered invalid data, please, try again';
          }
        });
    }
  }
};
</script>

<style scoped>
  body {
    background: #d2d6de;
  }
</style>

<style scoped>
  h1, h2 {
    font-weight: normal;
    color: #444;
  }

  .signin__input-group {
    margin-bottom: 12px;
  }

  .signin__button-wrapper {
    margin: 0 auto;
    width: 160px;
  }
</style>
